import {useContext} from "react";
import DisplayParams from "../DisplayParams";
import EventLogo from "./EventLogo";

const divisionSeedRegex = /^([A-Z]+)([0-9]+)?$/;

export default function FormattedSeed({seed, compact, semiCompact}: {seed: string, compact?: boolean, semiCompact?: boolean}) {
    const displayParameters = useContext(DisplayParams)
    const match = divisionSeedRegex.exec(seed)
    if(!match || !displayParameters.divisions) {
        return compact ? `A${seed}` : `Alliance ${seed}`;
    }
    const abbrev = match[1];
    const numSeed = match[2];

    const div = Object.values(displayParameters.divisions).find(d => d.abbrev == abbrev)
    if(!div) {
        return compact ? `A${seed}` : `Alliance ${seed}`;
    }
    // FIRST championship division names are known lengths and should be used in lieu of abbreviations
    return <span className={"d-inline-block"}>{div.logo ? <><EventLogo logo={div.logo} /> </> : null}{(compact || semiCompact) && !displayParameters.isFirstChampionship ? div.abbrev : div.name}{numSeed ? <>&nbsp;{numSeed}</> : null}</span>;
}